import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Box, Container, Typography } from "@mui/material";
import Vision1 from "../../assets/images/aboutus-vision1.png";
import Vision2 from "../../assets/images/Vision2.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function Vision() {
  const mobMatch = useMediaQuery("(max-width:600px)");

  return (
    <>
      <Box
        sx={{
          display: "flex",
          backgroundColor: { xs: "#fff", sm: "none" },
          alignItems: "center",
          textAlign: { sm: "center" },
          marginTop: { sm: "56px" },
          marginBottom: { xs: "16px", sm: "72px" },
          flexFlow: "column",
          rowGap: { xs: "8px", sm: "24px" },
          padding: { xs: "16px 24px", sm: "0px" },
          boxShadow: {
            xs: "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
            sm: "none",
          },
          borderRadius: { xs: "0px 0px 8px 8px", sm: "0" },
        }}
      >
        <Box
          sx={{
            display: { xs: "flex", sm: "none" },
            width: "100%",
            marginBottom: "28px",
            marginLeft: "-8px",
            backgroundColor: "white",
          }}
        >
          <ArrowBackIcon
            sx={{
              color: "primary.main",
            }}
          />
        </Box>
        <Typography
          variant={mobMatch ? "h3" : "h1"}
          sx={{
            fontSize: { xs: "22px", sm: "48px" },
            lineHeight: { xs: "26px", sm: "52px" },
            fontWeight: { xs: "600", sm: "700" },
            width: { sm: "699px" },
          }}
        >
          We make buying and selling of heavy machinery delightful
        </Typography>
        <Typography
          variant={mobMatch ? "caption" : "body1"}
          sx={{
            fontSize: { xs: "12px", sm: "16px" },
            lineHeight: { xs: "16px", sm: "24px" },
          }}
        >
          Machinery Planet is a leading digital marketplace for selling and
          selling heavy equipment online. It stands as a hyphen between the
          buyers and sellers of heavy equipment, allowing them to interact,
          discuss, negotiate and close transactions in a timely, professional,
          transparent and cost-effective manner.
        </Typography>
      </Box>
      <Container
        disableGutters={true}
        sx={{
          backgroundColor: "#1F1F1F",
          borderRadius: { xs: "8px", sm: "16px" },
          height: { xs: "304px", sm: "352px" },
          display: "flex",
          alignItems: { sm: "center" },
          backgroundImage: `url(${mobMatch ? Vision2 : Vision1})`,
          backgroundRepeat: "no-repeat",
          backgroundPositionX: "90%",
          backgroundPositionY: "100%",
          backgroundSize: { xs: "274px", sm: "contain" },
          marginBottom: { xs: "16px", sm: "72px" },
          boxShadow: {
            xs: "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
            sm: "none",
          },
          padding: { xs: "16px 24px", sm: "0px" },
        }}
      >
        <Box sx={{ width: "536px", marginLeft: { sm: "40px" } }}>
          <Typography
            variant={mobMatch ? "subtitle2" : "subtitle1"}
            sx={{
              fontSize: { xs: "14px", sm: "16px" },
              lineHeight: { xs: "20px", sm: "24px" },
              fontWeight: 600,
              color: "#D6D6D6",
              marginBottom: "8px",
            }}
          >
            Our vision
          </Typography>
          <Typography
            variant={mobMatch ? "h3" : "h2"}
            sx={{
              fontSize: { xs: "22px", sm: "32px" },
              lineHeight: { xs: "26px", sm: "36px" },
              fontWeight: { xs: "600", sm: "700" },
              color: "#fff",
            }}
          >
            “Making the process of sourcing heavy machinery and trucks a
            hassle-free job”
          </Typography>
        </Box>
      </Container>
    </>
  );
}

export default Vision;
